export interface JwtPayload {
    iss?: string;
    sub?: string;
    aud?: string | string[];
    jti?: string;
    nbf?: number;
    exp?: number;
    iat?: number;
    [propName: string]: unknown;
}

export function decodeJwt(jwt: string): JwtPayload {
    if (typeof jwt !== 'string')
        throw new Error('JWTs must use Compact JWS serialization, JWT must be a string');

    const { 1: payload, length } = jwt.split('.');

    if (length === 5)
        throw new Error('Only JWTs using Compact JWS serialization can be decoded');
    if (length !== 3)
        throw new Error('Invalid JWT');
    if (!payload)
        throw new Error('JWTs must contain a payload');

    let decoded: string;
    try {
        const encoded = payload.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
        decoded = atob(encoded);
    } catch {
        throw new Error('Failed to base64url decode the payload');
    }

    let result: unknown;
    try {
        result = JSON.parse(decoded);
    } catch {
        throw new Error('Failed to parse the decoded payload as JSON');
    }

    if (!isPlainObject(result))
        throw new Error('Invalid JWT Claims Set');

    return result as JwtPayload;
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
    if (typeof value !== 'object' || value === null) return false;
    if (Object.prototype.toString.call(value) !== '[object Object]') return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    let p = value;
    while (Object.getPrototypeOf(p) !== null) {
        p = Object.getPrototypeOf(p);
    }
    return Object.getPrototypeOf(value) === p;
}
